import axios from "../../config/axiosConfig";
import { PRODUCTION_TRANSACTION_AVAILABLE_REQUEST, PRODUCTION_TRANSACTION_AVAILABLE_REQUEST_FAILURE, GET_PRODUCTION_TRANSACTIONS_AVAILABLE_TAKA_NO,
  GET_PRODUCTION_AVAILABLE_TRANSACTIONS } from "../types";

export const getProductionAvailableTransactions = (queryParams) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_TRANSACTION_AVAILABLE_REQUEST });
      const { auth } = getState();
      let params = { ...queryParams, customerId: auth?.user?.Customer_Id };
      console.log('>>>>>common production', auth?.company?.Common_Company);
      
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/production/available-production-transaction", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_AVAILABLE_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getProductionAvailableTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_TRANSACTION_AVAILABLE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/production/available-production-transaction", { params }).then((response) => {
        const takaNos = response.data.map((data) => data.Taka_No);
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_TRANSACTIONS_AVAILABLE_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const findProductionAvailableTransactionByTakaNo = (queryParams) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_TRANSACTION_AVAILABLE_REQUEST });
      const { auth } = getState();
      let params = { ...queryParams, customerId: auth?.user?.Customer_Id };
      console.log('>>>>>common production', auth?.company?.Common_Company);
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/production/find-available-production-transaction-by-taka-no", { params }).then((response) => {
          return response.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });
    }
  };
};
